import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const HeartUnborderedIcon = ({
  title = 'unbordered heart',
  viewBox = '0 0 24 24',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.074 5.605C11.09-.873 20.793-.961 26.908 5.342l.25.263 3.153 3.397 3.156-3.397c5.932-6.388 15.45-6.562 21.577-.522l.257.26.25.262c6.015 6.478 6.096 16.926.243 23.511l-.244.269-23.66 25.478c-.832.895-2.157.936-3.033.122l-.122-.122-23.66-25.478c-6.099-6.567-6.099-17.213 0-23.78Z"
    />
  </CreateIconComponent>
);

export default HeartUnborderedIcon;
